// extracted by mini-css-extract-plugin
export default {"container":"MemoInput_container__394So","input":"MemoInput_input__Dxeou","textContainer":"MemoInput_textContainer__ouTqQ","text":"MemoInput_text__TTKQ3"};